export default __webpack_public_path__ + "static/media/uwchampions.dcd41d68.png";